/* ==========================================================================
   Cookie Policy & Privacy Statement Page View (Multilingual)
   ========================================================================== */

import { t, getLocale } from '../locales/i18n.js';

export function renderCookiePolicyPage() {
  const page = document.createElement('div');
  page.className = 'sed-page-cookie-policy';
  const lang = getLocale() || 'en';
  const isCs = lang === 'cs';

  page.innerHTML = `
    <section class="sed-section">
      <div class="sed-container" style="max-width: 860px;">
        <div class="sed-section-header" style="text-align: left; margin-bottom: 2.5rem;">
          <div class="sed-eyebrow">${isCs ? 'OCHRANA SOUKROMÍ A COOKIES' : 'GDPR & Cookie Policy'}</div>
          <h1 class="sed-section-title">${isCs ? 'Zásady používání souborů cookie' : 'Cookie Policy & Privacy Statement'}</h1>
          <p class="sed-section-desc">${isCs ? 'Aktualizováno: Únor 2026. Sound Event Detector (JALUD Embedded s.r.o.) klade maximální důraz na transparentnost a dodržování evropských standardů ochrany soukromí.' : 'Last updated: February 2026. Sound Event Detector (JALUD Embedded s.r.o.) is committed to transparency and strict European data protection standards.'}</p>
        </div>

        <div style="background: #ffffff; border: 1.5px solid var(--slate-line); border-radius: 14px; padding: 2.5rem; line-height: 1.8; color: var(--text-dark); box-shadow: 0 4px 15px rgba(0,0,0,0.03);">
          <h2 style="font-family: var(--font-heading); font-size: 1.4rem; color: var(--navy-dark); margin-bottom: 1rem;">${isCs ? '1. Co jsou soubory cookie?' : '1. What Are Cookies?'}</h2>
          <p style="margin-bottom: 1.5rem;">
            ${isCs 
              ? 'Cookies jsou malé textové soubory ukládané ve vašem zařízení, které zajišťují správné fungování webu, pamatují si vámi zvolený jazyk a umožňují anonymní analýzu návštěvnosti.'
              : 'Cookies are small text files placed on your device to ensure proper website functionality, analyze visitor traffic, and improve security services.'}
          </p>

          <h2 style="font-family: var(--font-heading); font-size: 1.4rem; color: var(--navy-dark); margin-bottom: 1rem;">${isCs ? '2. Kategorie cookies, které používáme' : '2. Categorization of Cookies We Use'}</h2>
          
          <div style="margin-bottom: 1.5rem; padding: 1.25rem; background: var(--blue-ultra-light); border-left: 4px solid var(--blue-primary); border-radius: 8px;">
            <strong>${isCs ? 'A. Nezbytné (Technické) cookies:' : 'A. Essential Cookies (Strictly Necessary):'}</strong><br>
            ${isCs 
              ? 'Jsou nutné pro procházení webu, přepínání jazyků (CS, EN, DE, ES, PT, AR), bezpečnostní hlavičky a správný běh klientských relací. Tyto cookies nelze vypnout.'
              : 'Required for page navigation, language selection (EN, CZ, DE, ES, AR, PT), security headers, and session integrity. Cannot be disabled.'}
          </div>

          <div style="margin-bottom: 1.5rem; padding: 1.25rem; background: var(--blue-ultra-light); border-left: 4px solid var(--blue-primary); border-radius: 8px;">
            <strong>${isCs ? 'B. Analytické a výkonnostní cookies:' : 'B. Analytics & Performance Cookies:'}</strong><br>
            ${isCs 
              ? 'Pomáhají nám měřit anonymní návštěvnost a optimalizovat obsah webu (Google Tag Manager / Google Analytics). Načítají se pouze s vaším souhlasem.'
              : 'Helps us measure site performance and visitor interactions (Google Tag Manager / Analytics). Aggregated anonymously.'}
          </div>

          <div style="margin-bottom: 2rem; padding: 1.25rem; background: var(--blue-ultra-light); border-left: 4px solid var(--blue-primary); border-radius: 8px;">
            <strong>${isCs ? 'C. Garance nulového odposlechu u technologie SED:' : 'C. Sound Detector Privacy Guarantee:'}</strong><br>
            ${isCs 
              ? 'Náš hlavní produkt – Sound Event Detector – <strong>NIKDY nenahrává ani neukládá lidskou řeč</strong>. Zvukové algoritmy vyhodnocují pouze akustické bezpečnostní profily v reálném čase.'
              : 'Our core product — Sound Event Detector — does <strong>NOT</strong> record or store human conversations. Only security acoustic impulse algorithms evaluate audio in real-time. Zero ambient wiretapping occurs.'}
          </div>

          <h2 style="font-family: var(--font-heading); font-size: 1.4rem; color: var(--navy-dark); margin-bottom: 1rem;">${isCs ? '3. Nastavení a správa předvoleb' : '3. Managing Your Preferences'}</h2>
          <p style="margin-bottom: 1.5rem;">
            ${isCs 
              ? 'Své preference ohledně cookies můžete kdykoli změnit v cookie liště ve spodní části stránky nebo vymazáním historie ve vašem webovém prohlížeči.'
              : 'You can change your consent preferences at any time using the cookie settings banner or by clearing your browser cookies.'}
          </p>

          <div style="padding-top: 1.5rem; border-top: 1px solid var(--slate-line); font-size: 0.9rem; color: var(--text-muted);">
            ${isCs ? 'Správce údajů: JALUD Embedded s.r.o. · Kontakt: info@jalud.eu' : 'Data Controller: JALUD Embedded s.r.o. · Contact: info@jalud.eu'}
          </div>
        </div>
      </div>
    </section>
  `;

  return page;
}
